import * as React from "react";

interface PreviewMessageProps {
  message: string;
}

class PreviewMessage extends React.Component<PreviewMessageProps, {}> {
  public render() {
    let message = this.props.message;
    if (!message || !message.length) {
      return null;
    }

    if (message.length > 160) {
      message = message.slice(0, 160) + "...";
    }

    return (
      <div className="velaro-preview-message-row">
        <div className="velaro-preview-message">
          <span
            dangerouslySetInnerHTML={{
              __html: message
            }}
          />
        </div>
      </div>
    );
  }
}

export default PreviewMessage;
